import React, { useState } from 'react';
import './ApplicantInquiry.css';
import { useNavigate } from 'react-router-dom';
import Footer from '../../../Footer';
import careerIcon from '../../../../assets/Pages/Career/careerIcon.png';

const ApplicantInquiry = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    preferredRole: '',
    experience: '',
    availability: '',
    notes: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
    const { ...rest } = formData; // remove file for localStorage
    localStorage.setItem('applicantProfile', JSON.stringify(rest));
    navigate('/career/applicant-onboarding');
  };  

  return (
    <div>
      <div className='career-background-one-container'>
        <div className='container'>
          <div className='applicant-training-dashboard-container'>
            <img className='career-page-icon' src={careerIcon} alt="Careers at Pawsible" />
            <h2 className='career-page-heading'>Join Pawsible</h2>
            <p className='career-page-paragraph'>
              Let’s learn more about you. Please fill out the form below to begin your onboarding process.
            </p>
            <form className='applicant-form pawsible-form' onSubmit={handleSubmit}>
                <div className="form-group">
                    <label className='form-label'>Full Name*</label>
                    <input type='text' name='fullName' value={formData.fullName} onChange={handleChange} className='form-input' required />
                </div>

                <div className="form-group">
                    <label className='form-label'>Email*</label>
                    <input type='email' name='email' value={formData.email} onChange={handleChange} className='form-input' required />
                </div>

                <div className="form-group">
                    <label className='form-label'>Phone Number*</label>
                    <input type='tel' name='phone' value={formData.phone} onChange={handleChange} className='form-input' required />
                </div>

                <div className="form-group">
                    <label className='form-label'>Preferred Role*</label>
                    <select name='preferredRole' value={formData.preferredRole} onChange={handleChange} className='form-select' required >
                    <option value=''>Select Role</option>
                    <option value='Daycare'>Daycare</option>
                    <option value='Groomer'>Groomer</option>
                    <option value='Bather'>Bather</option>
                    <option value='Receptionist'>Receptionist</option>
                    <option value='Trainer'>Trainer</option>
                    <option value='Shuttle'>Shuttle Driver</option>
                    <option value='Manager'>Manager</option>
                    <option value='Marketer'>Marketing</option>
                    </select>
                </div>

                <div className="form-group">
                    <label className='form-label'>Availability*</label>
                    <input type='text' name='availability' value={formData.availability} onChange={handleChange} className='form-input' required />
                </div>

                <div className="form-group">
                    <label className='form-label'>Additional Notes</label>
                    <textarea name='notes' value={formData.notes} onChange={handleChange} className='form-textarea' />
                </div>

                <div className='applicant-inquiry-button-container'>
                    <button type='submit' className='applicant-inquiry-button'>Submit & Start Training</button>
                </div>
                </form>
          </div>
        </div>
      </div>
      <hr />
      <Footer />
    </div>
  );
};

export default ApplicantInquiry;
